import api from "./api";
import Category from "@/model/category";

class CategoryApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getMainCategories() {
    const response = await this.getHttp().get<any>('items');
    const categories = response.data.data.categories;
    const result = []

    categories.map(item => {
      if (item.superItemCategory === "") {
        result.push(item)
      }
    })

    return result.map(item => {
      return new Category(item)
    })
  }

  async getSubCategories() {
    const response = await this.getHttp().get<any>('items');
    const categories = response.data.data.categories;
    const result = []

    categories.map(item => {
      if (item.superItemCategory !== "") {
        result.push(item);
      }
    });

    return result.map(item => {
      return new Category(item)
    });
  }

  async getFirstSubCategoryByIdentifier(identifier, subCategories) {
    const result = []
    subCategories.map(item => {
      if (item.superItemCategory === identifier) {
        result.push(item);
      }
    });

    if (result.length > 0) {
      return result[0].identifier
    }

    return result;
  }
}

export default new CategoryApi();
